// Applies a widget's discount code to the cart when its Add to Cart button is
// clicked (LM shop-page monthly-special widgets). Uses the same Cart AJAX API
// discount mechanism as cart-coupon.js. Failure behavior: if the add itself
// fails the form falls back to a native submit; if only the discount step
// fails the code is applied server-side via the /discount/CODE route instead.
if (!window.lmDiscountAddBound) {
  window.lmDiscountAddBound = true;

  // Back/forward cache restores DOM state, so a button disabled before the
  // redirect would come back dead when the customer presses Back from /cart.
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    document.querySelectorAll("button[data-discount-code][disabled]").forEach((button) => {
      button.disabled = false;
    });
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const button = form.querySelector("button[data-discount-code]");
    const code = button && button.dataset.discountCode ? button.dataset.discountCode.trim() : "";
    if (!code) return;
    if (!/\/cart\/add/.test(form.getAttribute("action") || "")) return;

    event.preventDefault();
    button.disabled = true;

    (async () => {
      let added = false;
      try {
        const addResponse = await fetch(routes.cart_add_url + ".js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!addResponse.ok) throw new Error("Cart add failed: " + addResponse.status);
        added = true;

        const cartResponse = await fetch(routes.cart_url + ".js", {
          headers: { "Content-Type": "application/json", Accept: "application/json" },
        });
        if (!cartResponse.ok) throw new Error("Cart read failed: " + cartResponse.status);
        const cart = await cartResponse.json();

        // Merge with any codes the customer already applied (mirrors cart-coupon.js)
        const codes = (cart.discount_codes || []).map((discount) => discount.code);
        if (!codes.some((existing) => existing.toUpperCase() === code.toUpperCase())) {
          codes.push(code);
        }

        const updateResponse = await fetch(routes.cart_update_url + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: codes.join(",") }),
        });
        if (!updateResponse.ok) throw new Error("Cart update failed: " + updateResponse.status);
        const updatedCart = await updateResponse.json();

        const applied = (updatedCart.discount_codes || []).some(
          (discount) => discount.code.toUpperCase() === code.toUpperCase() && discount.applicable
        );
        if (!applied) {
          // Merchant signal: the widget's hand-typed code doesn't match an
          // active discount in Admin → Discounts (e.g. a typo or expired code).
          console.warn('lm-discount-add: discount code "' + code + '" was accepted but is not applicable to this cart.');
        }

        button.disabled = false;
        window.location.href = routes.cart_url;
      } catch (error) {
        console.error("lm-discount-add:", error);
        button.disabled = false;
        if (!added) {
          // Item never made it into the cart — let the browser do a normal add
          form.submit();
          return;
        }
        // Item is in the cart but the AJAX discount step failed — have Shopify
        // apply the code server-side on the way to the cart.
        window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(routes.cart_url);
      }
    })();
  });
}
